import { projectDataType } from ".";

const hashTagDData: projectDataType = {
  path: "hashtagD",
  title: "Dimensional Navigation Simulator",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964489/Art-Site/HashtagD/hshtagd-inivte-1.jpg",
  description:
    "#D was a an art show curated by Giselle Zatonyl, at Bronx Art Space.",
  year: 2012,
  invitations: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964489/Art-Site/HashtagD/hshtagd-inivte-1.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964488/Art-Site/HashtagD/229995_4156952881628_4407119_n_uyqe5a.jpg",
  ],
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964490/Art-Site/HashtagD/sara_ludy_zynb07.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964491/Art-Site/HashtagD/ryan_estep_jp1zh5.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964490/Art-Site/HashtagD/ryan_estep_detail_fmnzli.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964491/Art-Site/HashtagD/jessica_sanders_fur_vba7gf.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964490/Art-Site/HashtagD/jessica_sanders_wax_planks_edlqsq.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964489/Art-Site/HashtagD/jessica_sanders_sugar_vfezki.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964488/Art-Site/HashtagD/jessica_gispert_ofx2bt.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964489/Art-Site/HashtagD/bhati_uvkqk9.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964488/Art-Site/HashtagD/bhakti_detail_jftepn.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964490/Art-Site/HashtagD/emilio_udggb4.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964490/Art-Site/HashtagD/v5mt_cojgwr.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964490/Art-Site/HashtagD/manuek_fernandez_nrue1k.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964488/Art-Site/HashtagD/anthony_antonellis_all_u7trov.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964490/Art-Site/HashtagD/anthont_antonellis_detail_ngjwy0.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964489/Art-Site/HashtagD/anthony_detail_dfd3yq.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964488/Art-Site/HashtagD/yoshi_gqasae.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964491/Art-Site/HashtagD/lorna_mills_fqmxvw.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964491/Art-Site/HashtagD/eva_papamargariti_tm4shz.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964488/Art-Site/HashtagD/erik_h_zepka_jju6he.jpg",
  ],
  installPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964489/Art-Site/HashtagD/283725_4205629418511_1188971991_n_suilfp.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964489/Art-Site/HashtagD/528011_4205586937449_53312481_n_fju3p4.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964490/Art-Site/HashtagD/314832_4205627618466_1970357561_n_wyfyiq.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964491/Art-Site/HashtagD/315314_4205630098528_1825139753_n_cuj2rc.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964491/Art-Site/HashtagD/555220_4205613858122_243775444_n_itxhji.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964491/Art-Site/HashtagD/523954_4205620538289_1587179280_n_oxel3q.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964488/Art-Site/HashtagD/306671_4205612738094_1845353905_n_savvsw.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964491/Art-Site/HashtagD/179950_4205626578440_1690231786_n_dd5f6m.jpg",
  ],
};

export default hashTagDData;
